// components/FeatureLockedMessage.jsx

import React from "react";
import { Box, Text, Button, Icon, VStack } from "@chakra-ui/react";
import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

const FeatureLockedMessage = ({ featureName  }) => {
  const navigate = useNavigate();

  return (
    <Box
      borderWidth="1px"
      borderRadius="2xl"
      borderStyle="dashed"
      borderColor="gray.300"
      bg="gray.50"
      p={6}
      textAlign="center"
      boxShadow="sm"
    >
      <VStack spacing={3}>
        <Icon as={Lock} w={6} h={6} color="gray.500" />
        <Text fontSize="lg" fontWeight="semibold">
          Upgrade to access {featureName}
        </Text>
        <Text fontSize="sm" color="gray.600">
          This feature is only available on the Standard or Enterprise plan.
        </Text>
        <Button
          colorScheme="blue"
          onClick={() => navigate("/payment")}
          size="sm"
        >
          Upgrade Plan
        </Button>
      </VStack>
    </Box>
  );
};

export default FeatureLockedMessage;
